import { gql } from '@apollo/client';

const CHANGE_FIELDS = gql`
    fragment ChannelConfigChangeFields on ChannelConfigChangeType {
        path
        section
        kind
        before
        after
        itemName
    }
`;

const VERSION_FIELDS = gql`
    fragment ChannelConfigVersionFields on ChannelConfigVersionType {
        number
        source
        sourceName
        restoredFromNumber
        changedPaths
        createdAt
        createdByName
        createdByEmail
    }
`;

export const GET_CHANNEL_CONFIG_VERSIONS = gql`
    ${VERSION_FIELDS}
    query ChannelConfigVersions($documentType: DocumentTypeEnum!, $channelId: UUID!) {
        channelConfigVersions(documentType: $documentType, channelId: $channelId) {
            ...ChannelConfigVersionFields
        }
    }
`;

export const GET_CHANNEL_CONFIG_VERSION_DIFF = gql`
    ${CHANGE_FIELDS}
    query ChannelConfigVersionDiff(
        $documentType: DocumentTypeEnum!
        $channelId: UUID!
        $fromNumber: Int
        $toNumber: Int
    ) {
        channelConfigVersionDiff(
            documentType: $documentType
            channelId: $channelId
            fromNumber: $fromNumber
            toNumber: $toNumber
        ) {
            ...ChannelConfigChangeFields
        }
    }
`;

export const RESTORE_CHANNEL_CONFIG_VERSION = gql`
    mutation RestoreChannelConfigVersion(
        $documentType: DocumentTypeEnum!
        $channelId: UUID!
        $number: Int!
        $paths: [String!]
    ) {
        restoreChannelConfigVersion(
            documentType: $documentType
            channelId: $channelId
            number: $number
            paths: $paths
        ) {
            skippedPaths
        }
    }
`;

export const GET_CHANNEL_CONFIG_RISKY_FIELDS = gql`
    ${VERSION_FIELDS}
    query ChannelConfigRiskyFields($documentType: DocumentTypeEnum!, $channelId: UUID!) {
        channelConfigRiskyFields(documentType: $documentType, channelId: $channelId) {
            path
            kind
            value
            version {
                ...ChannelConfigVersionFields
            }
        }
    }
`;

export const EXPORT_CHANNEL_CONFIG = gql`
    mutation ExportChannelConfig(
        $documentType: DocumentTypeEnum!
        $channelId: UUID!
        $number: Int!
        $sections: [String!]!
    ) {
        exportChannelConfig(documentType: $documentType, channelId: $channelId, number: $number, sections: $sections) {
            data
        }
    }
`;

export const PREVIEW_CHANNEL_CONFIG_IMPORT = gql`
    ${CHANGE_FIELDS}
    mutation PreviewChannelConfigImport($documentType: DocumentTypeEnum!, $channelId: UUID!, $file: Upload!) {
        previewChannelConfigImport(documentType: $documentType, channelId: $channelId, file: $file) {
            exportedFromChannelName
            exportedFromCustomerName
            exportedAt
            exportedByName
            changes {
                ...ChannelConfigChangeFields
            }
        }
    }
`;

export const IMPORT_CHANNEL_CONFIG = gql`
    mutation ImportChannelConfig(
        $documentType: DocumentTypeEnum!
        $channelId: UUID!
        $file: Upload!
        $paths: [String!]!
    ) {
        importChannelConfig(documentType: $documentType, channelId: $channelId, file: $file, paths: $paths) {
            success
        }
    }
`;

export const CHANNEL_CONFIG_REFETCH_QUERIES = ['ChannelConfigVersions'];
